import React from 'react';

import GenericModal from '../../../components/agv-generic-modal';
import { MODAL_SIZE, MODAL_SIZE_STYLE } from '../../../enums/modal-size.enum';
import { CLIENT_SECTION, groupDiffBySection } from '../client-diff';
import { Banner } from '../clients-ui';
import { PricingNotRetroactiveNotice } from '../steps/pricing-step';
import ClientChangesDiff from './client-changes-diff';

/**
 * Récapitulatif d'un client existant : seulement ce qui a changé, section par
 * section (options comprises), avant / après. À confirmer avant
 * l'enregistrement, puis tracé dans l'historique du client.
 */
export default function ClientChangesReviewModal({
  isOpen,
  setIsOpen,
  clientName,
  diff,
  onConfirm,
  isSaving,
}) {
  const groups = groupDiffBySection(diff);
  const hasPricingChanges = groups.some(
    (group) => group.section === CLIENT_SECTION.PRICING
  );
  const hasOptionsChanges = groups.some(
    (group) => group.section === CLIENT_SECTION.OPTIONS
  );

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={`Récapitulatif des modifications — ${clientName}`}
      size={MODAL_SIZE_STYLE[MODAL_SIZE.XL]}
      secondaryActionText="Retour à la saisie"
      secondaryAction={() => setIsOpen(false)}
      mainActionText={`Enregistrer ${diff.length} modification${diff.length > 1 ? 's' : ''}`}
      mainAction={onConfirm}
      mainActionDisabled={!diff.length}
      mainActionIsLoading={isSaving}
    >
      <div className="tw-flex tw-flex-col tw-gap-4">
        <p className="tw-m-0 tw-text-sm">
          Vérifiez les modifications avant de les enregistrer. Elles seront
          tracées dans l’historique du client, avec votre nom.
        </p>
        {hasOptionsChanges && (
          <Banner tone="warn">
            Client en service : les options sont transmises dans le jeton de
            connexion, ses utilisateurs les verront à leur prochaine connexion.
          </Banner>
        )}
        {groups.map((group) => (
          <div key={group.section} className="tw-flex tw-flex-col tw-gap-2">
            <p className="tw-m-0 tw-text-[11px] tw-font-semibold tw-uppercase tw-text-[rgba(0,0,0,0.45)]">
              {group.label} · {group.changes.length} modification
              {group.changes.length > 1 ? 's' : ''}
            </p>
            {group.section === CLIENT_SECTION.PRICING && hasPricingChanges && (
              <PricingNotRetroactiveNotice />
            )}
            <ClientChangesDiff
              diff={group.changes}
              stripRoot={group.section !== CLIENT_SECTION.INFORMATION}
            />
          </div>
        ))}
      </div>
    </GenericModal>
  );
}
